import { Dialog, DialogTitle, DialogContent, Button, Box, Typography, Grid, IconButton, TextField, Autocomplete, FormHelperText, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import React, { useState } from 'react';
import { useDispatch } from 'store';
import { RxCross2 } from "react-icons/rx";
import { useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useCreateLegalMutation } from "store/slices/apis/legalTrackerSlice";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import CancelIcon from '@mui/icons-material/Cancel';


const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};


// const statusOptions = [
//     { label: "Complied", value: "Complied" },
//     { label: "Not Complied", value: "Not Complied" },
//     { label: "Not Applicable", value: "Not Applicable" }
// ]


const LEGAL_TYPES = [
    { label: "BOCW", value: "BOCW" },
    { label: "WC & Migrant Worker", value: "WMW" },
    { label: "CEA", value: "CEA" },
    { label: "Environment", value: "Environment" },
    { label: "Motor Vehicle Act", value: "MVA" },
];

const MAX_TOTAL_SIZE = 30 * 1000 * 1000;

const AddLegal = (props) => {
    const { open, handleClose, refetchCounts } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [createLegal] = useCreateLegalMutation()

    const module = "legal Compliance"
    const { data: contactsData, isLoading, error } = useGetAllContactsQuery();
    const { data: statusData } = useGetMasterDataQuery({ module: module, category: 'StatusofCompliance', ProjectId: projectId });

    const statusOptions = statusData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    })) || [];

    const responsiblePersonOptions = React.useMemo(() => {
        if (!contactsData?.data) return [];

        return contactsData.data.map((item) => ({
            value: item.email,
            label: `${item.name}`,
        }));
    }, [contactsData]);


    const [formData] = useState({
        sectionRuleClause: "",
        applicableRequirementOfSection: "",
        requirementOfCompliance: "",
        complianceFrequency: "",
        responsibility: "",
        statusCompliance: "",
        complianceEvidence: [],
        remarks: "",
        type: "BOCW",
        category: ""
    });

    const validationSchema = Yup.object({

        // sectionRuleClause: Yup.string().required("Section/Rule/Clause is required"),
        applicableRequirementOfSection: Yup.string().required("Applicable requirement is required"),
        // requirementOfCompliance: Yup.string().required("Requirement of Compliance is required"),
        // complianceFrequency: Yup.string().required("Compliance of frequency is required"),
        // responsibility: Yup.string().required("Responsibility is required"),
        // statusCompliance: Yup.string().required("Status of Compliance is required"),
    });

    const validate = (values) => {
        const errors = {};

        const allFiles = [
            ...(values?.complianceEvidence || [])
        ];

        const totalSize = allFiles.reduce((acc, file) => acc + file.size, 0);

        if (totalSize >= MAX_TOTAL_SIZE) {
            errors.complianceEvidence = "Total file size must be less than 30MB";
        }

        return errors;
    };


    const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
        console.log("values", values)

        // const reqBody = {
        //     projectId: projectId,
        //     type: values?.type || "",
        //     sectionRuleClause: values.sectionRuleClause,
        //     applicableRequirement: values.applicableRequirementOfSection,
        //     requirementOfCompliance: values.requirementOfCompliance,
        //     complianceFrequency: values.complianceFrequency,
        //     responsibility: values.responsibility,
        //     statusOfCompliance: values.statusCompliance,
        //     complianceEvidence: values.complianceEvidence,
        //     remarks: values.remarks,
        //     category: values?.category || ""
        // };

        const formData = new FormData();

        formData.append("ProjectId", projectId);
        formData.append("Type", values?.type || "");
        formData.append("Category", values?.category || "");
        formData.append("SectionRuleClause", values.sectionRuleClause || "");
        formData.append("ApplicableRequirement", values.applicableRequirementOfSection || "");
        formData.append("RequirementOfCompliance", values.requirementOfCompliance || "");
        formData.append("ComplianceFrequency", values.complianceFrequency || "");
        formData.append("Responsibility", values.responsibility || "");
        formData.append("StatusOfCompliance", values.statusCompliance || "");
        formData.append("Remarks", values.remarks || "");

        if (values.complianceEvidence?.length) {
            values.complianceEvidence.forEach((file) => {
                formData.append("ComplianceEvidence", file);
            });
        }


        try {
            const resp = await createLegal(formData).unwrap()
            openNotification(resp.message, "success");
            refetchCounts()
            resetForm();
            handleClose();
        } catch (error) {
            //openNotification(error?.message ?? "Something went wrong", "error");
            console.log("API ERROR:", error);

            let errorMessage = "Something went wrong";

            if (error?.data?.errors) {
                errorMessage = Object.values(error.data.errors)
                    .flat()
                    .join(", ");
            } else if (error?.data?.title) {
                errorMessage = error.data.title;
            } else if (error?.error) {
                errorMessage = error.error;
            }

            openNotification(errorMessage, "error");
        } finally {
            setSubmitting(false);
        }

    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: { color: type },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleRemoveComplianceEvidence = (index, setFieldValue, values) => {
        const updateImages = values.complianceEvidence.filter((item, imgIdx) => imgIdx !== index)
        setFieldValue("complianceEvidence", updateImages)
    }

    return (
        <>
            <Dialog open={open}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}>
                    <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                        Add Legal
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>

                    <Formik
                        initialValues={formData}
                        validationSchema={validationSchema}
                        onSubmit={handleFormSubmit}
                        validate={validate}
                    >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <RadioGroup
                                        row
                                        name="type"
                                        value={values.type}
                                        onChange={handleChange}
                                    >
                                        {LEGAL_TYPES.map((t) => (
                                            <FormControlLabel
                                                key={t.value}
                                                value={t.value}
                                                control={<Radio />}
                                                label={t.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Category</Typography>
                                        <TextField
                                            fullWidth
                                            name="category"
                                            value={values.category}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Category"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.category && errors.category && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.category}
                                            </Typography>
                                        )}
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Section/Rule/Clause</Typography>
                                        <TextField
                                            fullWidth
                                            name="sectionRuleClause"
                                            value={values.sectionRuleClause}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Section/Rule/Clause"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.sectionRuleClause && errors.sectionRuleClause && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.sectionRuleClause}
                                            </Typography>
                                        )}
                                    </Grid>



                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Compliance Frequency</Typography>
                                        <TextField
                                            fullWidth
                                            name="complianceFrequency"
                                            value={values.complianceFrequency}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter compliance frequency"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.complianceFrequency && errors.complianceFrequency && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.complianceFrequency}
                                            </Typography>
                                        )}
                                    </Grid>


                                    {/* <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Responsibility</Typography>
                                        <Autocomplete
                                            options={responsiblePersonOptions}
                                            getOptionLabel={(option) => option?.label || ''}
                                            value={responsiblePersonOptions.find(opt => opt.value === values.responsibility) || null}
                                            onChange={(_, newValue) => setFieldValue('responsibility', newValue ? newValue.value : '')}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Responsibility"
                                                    name="responsibility"
                                                    size="small"
                                                    sx={{
                                                        "& input::placeholder": {
                                                            fontWeight: 400,
                                                            fontSize: "16px",
                                                            color: "#5F5F5F",
                                                            fontFamily: "Outfit, sans-serif",
                                                            opacity: 1,
                                                        },
                                                    }}
                                                />
                                            )}
                                            ListboxProps={{ sx: { fontSize: '13px' } }}
                                        />
                                        {touched.responsibility && errors.responsibility && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.responsibility}
                                            </Typography>
                                        )}
                                    </Grid> */}
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Responsibility</Typography>
                                        <TextField
                                            fullWidth
                                            name="responsibility"
                                            value={values.responsibility}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Responsibility"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.responsibility && errors.responsibility && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.responsibility}
                                            </Typography>
                                        )}
                                    </Grid>



                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Requirement of Compliance</Typography>

                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={3}
                                            name="requirementOfCompliance"
                                            value={values.requirementOfCompliance}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Requirement Of Compliance"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    "& textarea::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& textarea": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.requirementOfCompliance && errors.requirementOfCompliance && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.requirementOfCompliance}
                                            </Typography>
                                        )}
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Applicable requirement of the section/Rules/Clause</Typography>
                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={3}
                                            name="applicableRequirementOfSection"
                                            value={values.applicableRequirementOfSection}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter applicable requirement"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    "& textarea::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& textarea": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.applicableRequirementOfSection && errors.applicableRequirementOfSection && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.applicableRequirementOfSection}
                                            </Typography>
                                        )}
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 12 }}>
                                        <Typography sx={labelTextStyle}>Remarks</Typography>
                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={3}
                                            name="remarks"
                                            value={values.remarks}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter remarks"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    "& textarea::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& textarea": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.remarks && errors.remarks && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.remarks}
                                            </Typography>
                                        )}
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Status of Compliance</Typography>
                                        <Autocomplete
                                            options={statusOptions}
                                            getOptionLabel={(option) => option?.label || ''}
                                            value={statusOptions.find(opt => opt.value === values.statusCompliance) || null}
                                            onChange={(_, newValue) => setFieldValue('statusCompliance', newValue ? newValue.value : '')}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select status"
                                                    name="statusCompliance"
                                                    size="small"
                                                    sx={{
                                                        "& input::placeholder": {
                                                            fontWeight: 400,
                                                            fontSize: "16px",
                                                            color: "#5F5F5F",
                                                            fontFamily: "Outfit, sans-serif",
                                                            opacity: 1,
                                                        },
                                                    }}
                                                />
                                            )}
                                            ListboxProps={{ sx: { fontSize: '13px' } }}
                                        />
                                        {touched.statusCompliance && errors.statusCompliance && (
                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>
                                                {errors.statusCompliance}
                                            </FormHelperText>
                                        )}
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Compliance Evidence</Typography>
                                        {/* <TextField
                                            fullWidth
                                            name="complianceEvidence"
                                            value={values.complianceEvidence}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter compliance evidence"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        /> */}

                                        <Button variant="outlined" component="label" fullWidth sx={{ height: "40px" }}>
                                            Upload
                                            <input
                                                type="file"
                                                hidden
                                                multiple
                                                accept="image/*"
                                                onChange={(e) => {
                                                    const files = Array.from(e.target.files);
                                                    setFieldValue("complianceEvidence", [
                                                        ...values.complianceEvidence,
                                                        ...files
                                                    ]);
                                                }}
                                            />
                                        </Button>
                                        {touched.complianceEvidence && errors.complianceEvidence && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.complianceEvidence}
                                            </Typography>
                                        )}


                                        <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                                            {values.complianceEvidence.map((file, index) => (
                                                <Box key={index} textAlign="center" sx={{ position: "relative" }}>
                                                    <img
                                                        src={URL.createObjectURL(file)}
                                                        alt="preview"
                                                        width={80}
                                                        height={80}
                                                        style={{ objectFit: "cover", borderRadius: 6 }}
                                                    />
                                                    <IconButton
                                                        onClick={() => handleRemoveComplianceEvidence(index, setFieldValue, values)}
                                                        sx={{
                                                            position: "absolute",
                                                            top: 1,
                                                            right: 1,
                                                            p: 0,
                                                            backgroundColor: "rgba(0,0,0,0.6)",
                                                            color: "#fff",
                                                            "&:hover": {
                                                                backgroundColor: "rgba(244,67,54,0.9)"
                                                            },
                                                            zIndex: 2
                                                        }}>
                                                        <CancelIcon />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Grid>


                                    <Grid size={12}>
                                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                            <Button
                                                onClick={handleClose}
                                                sx={{
                                                    textTransform: "none",
                                                    color: "#F15744",
                                                    fontSize: "14px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    borderRadius: "25px",
                                                    fontWeight: 500,
                                                    px: "20px",
                                                    py: "15px",
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                disabled={isSubmitting}
                                                sx={{
                                                    backgroundColor: "#00344C",
                                                    borderRadius: "25px",
                                                    textTransform: "none",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    color: "#FFFFFF",
                                                    px: "20px",
                                                    py: "15px",
                                                    '&:hover': {
                                                        backgroundColor: "#002233",
                                                    }
                                                }}
                                            >
                                                {isSubmitting ? "Saving..." : "Save"}
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>

                </DialogContent>
            </Dialog>
        </>
    )
}

export default AddLegal
